import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.business_accounts_share_requirements.title',
        defaultMessage:
            'Need to ask your accountant or someone else for documents?'
    },
    subTitle: {
        id: '_.business_accounts_share_requirements.subTitle',
        defaultMessage:
            "If you don't have your documents to hand you can share the requirement list with someone who does."
    },
    shareRequirementList: {
        id: '_.business_accounts_share_requirements.shareRequirementList',
        defaultMessage: 'Email this list to someone'
    },
    shareRequiremenTitle: {
        id: '_.business_accounts_share_requirements.shareRequiremenTitle',
        defaultMessage: 'What documents do we need?'
    },
    pleaseMakeSure: {
        id: '_.business_accounts_share_requirements.pleaseMakeSure',
        defaultMessage: 'Please make sure...'
    },
    pleaseMakeSurePoints: {
        id: '_.business_accounts_share_requirements.pleaseMakeSurePoints',
        defaultMessage: 'Files are PDF or JPG, JPEG, PNG and no more than 2GB'
    },
    includingOptionalDocs: {
        id: '_.business_accounts_share_requirements.includingOptionalDocs',
        defaultMessage:
            'Including optional documents may increase your chance of approval'
    },
    copyRequirements: {
        id: '_.business_accounts_share_requirements.copyRequirements',
        defaultMessage: 'Copy required document list as text'
    },
    listCopied: {
        id: '_.business_accounts_share_requirements.listCopied',
        defaultMessage: 'List copied'
    }
});
